import { faBolt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function missingVoltageBus() {
    return (
        <div data-cy="history-missingVoltageBus">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.missingVoltageBus" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faBolt} style={{ color: 'red' }} size="lg" />
            </Whisper>
        </div>
    );
}
